import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const chapters = [
  { n: "01", title: "You Inquire",
    body: "Tell us who's traveling, when you want to go, your budget, and what you're celebrating &mdash; or escaping from." },
  { n: "02", title: "We Curate",
    body: "We match you with the right resort and accommodations based on your travel style, party, and pace." },
  { n: "03", title: "We Elevate",
    body: "Your VIP privileges, concierge details, and special experiences are coordinated before your arrival." },
  { n: "04", title: "You Escape",
    body: "Arrive knowing the details have already been considered. Slip in. Slow down. Everything is waiting." },
];

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.9, ease: [0.19, 1, 0.22, 1] } }),
};

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative bg-[#F9F6F0] py-24 md:py-40 z-[2]" data-testid="manifesto-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.9 }}
          className="grid grid-cols-12 gap-6 mb-16 md:mb-24"
        >
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#C5A059]" />
              <span className="eyebrow text-[#C5A059]">Chapter</span>
            </div>
            <h2 className="font-serif-editorial text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              A trip <span className="italic">designed</span>, not booked.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <p className="text-base md:text-lg leading-relaxed text-[#1A1A1A]/85 max-w-lg">
              The Elevated Escape sits between you and the resort — quietly arranging the details a five-star property would otherwise reserve for its most loyal members. You get the perks. You skip the paperwork.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-12 gap-y-16 md:gap-y-24 gap-x-6">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className={`col-span-12 md:col-span-6 ${i % 2 === 1 ? "md:col-start-7" : ""}`}
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="flex items-start gap-6 md:gap-10">
                <span className="font-serif-editorial text-[#C5A059] text-6xl md:text-8xl leading-none">{c.n}</span>
                <div className="pt-2 md:pt-4">
                  <h3 className="font-serif-editorial text-3xl md:text-4xl mb-4 italic">{c.title}</h3>
                  <p className="text-[#1A1A1A]/75 leading-relaxed max-w-sm" dangerouslySetInnerHTML={{ __html: c.body }} />
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.9 }}
          className="mt-20 md:mt-28 flex justify-center"
        >
          <a href="#inquiry" data-testid="manifesto-cta" className="ee-btn-primary">
            Start My Escape <ArrowUpRight size={14} strokeWidth={1.5} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
